module.exports = "<div class=\"icon-label\">\n  {{ label }}\n  <img src=\"../../../../assets/img/svg/{{ icon }}.svg\" />\n</div>\n"